// src/environments/environment.ts
export const environment = {
    production: false, // false 
    apiUrl: 'https://rda-dev.itehk-services.com/api',
    fileStorageBaseUrl: 'https://rda-dev.itehk-services.com/storage/' 
    // apiUrl: 'https://admin.rda.org.hk/api',
    // fileStorageBaseUrl: 'https://admin.rda.org.hk/storage/' 
  };